import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

mixpanel.init(MIXPANEL_TOKEN, {
  debug: process.env.NODE_ENV !== 'production', // Optional: enable logging in dev
  track_pageview: false,
  ignore_dnt: true
});

export default mixpanel;
